import React, { useState } from 'react';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, message, status }) => {

    const [boletoCancelado, setBoletoCancelado] = useState('N'); // default = 'N'

    if (!isOpen) {
        return null;
    }

    const handleConfirm = () => {
        // Passa o valor escolhido no confirm
        onConfirm(boletoCancelado);
    };

    console.log(status);

    // O modal deve ser renderizado como um overlay na tela
    return (
        <div style={modalStyles.overlay}>
            <div style={modalStyles.modal}>
                <div style={modalStyles.header}>
                    <h3>Confirmação</h3>
                </div>
                <div style={modalStyles.body}>
                    <p>{message}</p>
                </div>

                {(status === "baixa" || status === "baixa_lote") && (
                    <div style={{ marginTop: "10px", marginBottom: "20px", textAlign: "left" }}>
                        <label style={{ marginRight: "15px" }}>
                            Boleto cancelado:
                            <input
                                type="radio"
                                name="boletoCancelado"
                                value="S"
                                checked={boletoCancelado === "S"}
                                onChange={() => setBoletoCancelado("S")}
                            />
                            Sim
                        </label>
                        <label>
                            <input
                                type="radio"
                                name="boletoCancelado"
                                value="N"
                                defaultChecked
                                checked={boletoCancelado === "N"}
                                onChange={() => setBoletoCancelado("N")}
                            />
                            Não
                        </label>
                    </div>
                )}

                <div style={modalStyles.footer}>
                    <button onClick={onClose} style={modalStyles.buttonCancel}>Cancelar</button>
                    <button onClick={handleConfirm} style={modalStyles.buttonConfirm}>Confirmar</button>
                </div>
            </div>
        </div>
    );
};

// Exemplo de estilos simples para o modal
const modalStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000 // Garante que o modal fique acima dos outros elementos
    },
    modal: {
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        width: '400px',
        maxWidth: '90%',
        textAlign: 'center',
    },
    header: {
        marginBottom: '15px',
        borderBottom: '1px solid #ddd',
        paddingBottom: '10px'
    },
    body: {
        marginBottom: '20px'
    },
    footer: {
        display: 'flex',
        justifyContent: 'space-around',
    },
    buttonConfirm: {
        padding: '10px 20px',
        borderRadius: '4px',
        border: 'none',
        backgroundColor: '#007bff',
        color: '#fff',
        cursor: 'pointer'
    },
    buttonCancel: {
        padding: '10px 20px',
        borderRadius: '4px',
        border: '1px solid #ccc',
        backgroundColor: '#fff',
        cursor: 'pointer'
    }
};

export default ConfirmationModal;